import React from 'react';
import Badge from '../Badge';

interface TopicExamplesListProps {
  examples: string[];
  title?: string;
  className?: string;
  maxDisplay?: number;
}

export const TopicExamplesList: React.FC<TopicExamplesListProps> = ({
  examples,
  title = "Examples",
  className = "",
  maxDisplay = 10
}) => {
  if (!examples || examples.length === 0) {
    return null;
  }

  const displayExamples = examples.slice(0, maxDisplay);
  const hasMore = examples.length > maxDisplay;

  return (
    <div className={`space-y-2 ${className}`}>
      {title && (
        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {title} ({examples.length})
        </h4>
      )}
      <div className="flex flex-wrap gap-1.5">
        {displayExamples.map((example, index) => (
          <Badge
            key={index}
            text={example}
            variant="info"
            size="sm"
            className="bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100 transition-colors"
          />
        ))}
        {hasMore && (
          <Badge
            text={`+${examples.length - maxDisplay} more`}
            variant="default"
            size="sm"
            className="bg-gray-50 text-gray-500 border border-gray-200"
          />
        )}
      </div>
    </div>
  );
};